module.exports = __webpack_public_path__ + "img/loading.96cbeaa2.gif";